import ralphPic from "@/public/images/artists/ralph.png";
import { Artist } from "@/types/types";

export const ralph = {
  id: "173",
  name: "Ralph",
  image: ralphPic,
  description: `Ralph's seasoned voice is a natural fit for classic rock, blending a worn, matured timbre with vibrant intonation for depth and energy.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fralph-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Rock", "Unprocessed", "Mature", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Low",
      },
      specific: {
        low: 48,
        high: 65,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
